import device from "src/styles/device";
import styled, { css } from "styled-components";
import { Black, DarkGrey, Grey, GreyStroke, Primary } from "src/styles/color";
import { Box, Grid, styled as styledMUI, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import font from "src/styles/font";

export const Condition = styled.section`
  width: 100%;
  border-bottom: ${({ isAdmin }) => isAdmin && "1px solid #d8d8dc"};
  margin: ${({ isAdmin }) => (isAdmin ? "8px 0 24px 0" : "8px 0 0 0")};
  padding: 24px 0;

  @media ${device.laptop} {
    padding: 16px 0;
  }
`;

export const Title = styled.strong`
  color: ${({ primary }) => (primary ? "#E13B30" : "#252525")};
  font-size: 1rem;
  margin: auto 0;
  font-weight: 600;

  @media ${device.laptop} {
    font-size: 0.875rem;
  }
`;

export const Topic = styled.p`
  font-weight: 500;
  font-size: 0.875rem;
  color: ${({ primary }) => (primary ? Primary : "#bcbcc0")};
  margin: 0 0 8px 0;

  @media ${device.laptop} {
    font-size: 0.75rem;
  }
`;

export const Desc = styled.p`
  font-size: 1rem;
  font-weight: 400;
  color: ${({ primary }) => (primary ? Primary : "#252525")};
  margin: ${({ margin }) => (margin ? margin : "8px 0 0 0")};
  margin-bottom: ${({ mb }) => (mb ? `${mb}px` : "0")};
  ${({ isLink }) =>
    isLink &&
    css`
      text-decoration: underline;
      cursor: pointer;
    `}
  max-width: 90%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  @media ${device.laptop} {
    font-size: 0.875rem;
  }

  @media ${device.mobileL} {
    margin-top: ${({ unMarginTop }) => unMarginTop & "0"};
    font-size: 0.75rem;
  }
`;

export const TextTable = styled.p`
  font-size: 0.875rem;
  color: ${Black};
  font-weight: 400;
  margin: 2px 0;
  text-align: ${({ textAlign }) => textAlign};
  overflow: hidden; /* Hide any overflowing text */
  display: -webkit-box; /* Use a flexbox-like display model */
  -webkit-line-clamp: 2; /* Limit to 2 lines */
  -webkit-box-orient: vertical;

  @media ${device.laptop} {
    font-size: 0.75rem;
  }
`;

export const Column = styledMUI(Grid)`
  height: 40px;
  background-color: #f3f1f2;
  font-size: 0.875rem;
  font-weight: 500;
  /* padding: 8px 0; */

  @media ${device.laptop} {
    height: 32px;
    font-size: 0.75rem;
  }
`;

export const PdImage = styled.img`
  width: 64px;
  height: 64px;
  border-radius: 16px;
  position: relative;
  object-fit: cover;
  object-position: center;

  @media ${device.laptop} {
    width: 48px;
    height: 48px;
  }
`;

export const ImageEmpty = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 64px;
  height: 64px;
  background: #f2f1f3;
  border-radius: 16px;
  object-fit: cover;
  object-position: center;
  cursor: pointer;
  vertical-align: initial;

  &:hover {
    opacity: 0.8;
  }

  @media ${device.laptop} {
    width: 48px;
    height: 48px;
  }
  @media ${device.tabletL} {
    border-radius: 8px;
  }
`;

export const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: #d8d8dc;
  margin-bottom: 24px;

  @media ${device.laptop} {
    margin-bottom: 16px;
  }
`;

export const WrapperProductList = styled.div`
  width: 100%;
  overflow: hidden;
  overflow-x: auto;
`;

export const GridColumn = styled(Grid)`
  width: 100%;
  align-items: center;

  @media ${device.tabletL} {
    min-width: 580px;
  }
`;

export const GridRow = styled(Grid)`
  width: 100%;
  border-bottom: 1px solid #d8d8dc;

  @media ${device.tabletL} {
    min-width: 580px;
  }
`;

export const Table = styled(Grid)``;

export const SubColumn = styled(Grid)`
  padding: 8px;
  font-size: 0.875rem;
  font-weight: 500;
`;

export const TextSubTable = styled.p`
  color: #6c6c70;
  font-size: 0.75rem;
  font-weight: 400;
  margin: 2px 0;
`;

export const Payment = styled.section`
  width: 100%;
`;

export const Section = styled.section`
  width: 100%;
  border-top: ${({ borderTop }) => borderTop && `1px solid #D8D8DC`};
  border-bottom: ${({ borderBottom }) => borderBottom && `1px solid #D8D8DC`};
  padding-bottom: ${({ borderBottom }) => borderBottom && "24px"};
  display: flex;
  flex-wrap: wrap;

  @media ${device.tabletL} {
    padding-bottom: 16px;
  }
`;

export const Price = styled.p`
  font-size: 1.5rem;
  color: #e13b30;
  font-weight: 600;
  margin: 0 5px 0 0;

  @media ${device.tabletL} {
    font-size: 1.25rem;
  }
`;

export const InfoDoc = styled.span`
  font-size: 0.875rem;
  color: ${({ isDate }) => (isDate ? "#6C6C70" : "#252525")};
  font-weight: 500;
  margin-left: ${({ isDate }) => isDate && "8px"};

  @media ${device.tabletL} {
    font-size: 0.75rem;
  }
`;

export const StyledDatePicker = styled(DatePicker)`
  .MuiOutlinedInput-root {
    padding-right: 12px;

    @media ${device.mobileL} {
      height: 100%;
      border-radius: 12px !important;
    }
  }
  &.MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${DarkGrey};
  }
  .Mui-disabled,
  &.Mui-disabled .MuiOutlinedInput-notchedOutline {
    border-color: ${GreyStroke};
  }
  .MuiInputAdornment-root {
    display: flex !important;
  }
`;

export const TextFieldDialog = styled(TextField)`
  .MuiOutlinedInput-root {
    height: 48px;
    @media ${device.mobileL} {
      height: 100%;
      border-radius: 12px !important;
      font-size: 0.875rem !important;
    }
  }

  .MuiInputBase-input {
    padding-top: 0;
    padding-bottom: 0;
  }

  @media ${device.mobileL} {
    height: 40px;
  }
`;

export const StyledTextField = styled(TextField)`
  .MuiInputBase-adornedEnd {
    padding-right: 2px;
  }
  .MuiOutlinedInput-root {
    height: 48px;
    @media ${device.mobileL} {
      height: 100%;
      border-radius: 12px !important;
      height: 40px;
    }
  }
  .MuiOutlinedInput-input {
    @media ${device.mobileL} {
      font-size: 0.875rem;
    }
  }
`;

export const SpanLabel = styled.div`
  font-size: ${font.size.sm};
  font-weight: 500;
  line-height: 24px;
  margin-bottom: ${({ isMargin }) => isMargin && "4px"};
  color: ${({ highlight }) => (highlight ? Primary : "#252525")};

  span {
    font-size: ${font.size.sm};
    font-weight: 500;
    line-height: 24px;
    color: ${Primary};
  }

  @media ${device.mobileL} {
    font-size: ${font.size.xs};
  }
`;

export const SpanRemarkLabel = styled.span`
  font-size: ${font.size.xs} !important;
  font-weight: 500;
  line-height: 24px;
  color: ${Grey} !important;
`;

export const LabelErrors = styled.div`
  color: #bf0013;
  font-size: 0.75rem;
  width: 100%;
  padding: 0 16px;
  margin-top: 4px;
`;

export const WrapEdit = styled.div`
  display: flex;
  margin-left: 25px;
  align-items: flex-end;
  cursor: pointer;
`;

export const Button = styled.button`
  padding: 10px 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.875rem;
  border-radius: 14px;
  background-color: #06c755;
  border: none;
  color: #ffffff;
  font-weight: 500;
  cursor: pointer;

  :hover {
    opacity: 0.9;
  }

  @media ${device.tablet} {
    font-size: 0.75rem;
    padding: 8px 14px;
    border-radius: 12px;
  }
  @media ${device.mobile} {
    padding: 6px 12px;
    border-radius: 10px;
  }
`;

// lalamove component

export const TextOption = styled(Box)`
  width: 100%;
  color: ${DarkGrey};
  font-size: ${({ size }) => (size === "title" ? font.size.sm : font.size.xs)};
  font-weight: ${({ size }) => (size === "title" ? 500 : 400)};

  &:not(:last-child) {
    margin-bottom: 4px;
  }
`;

export const RemarkText = styled.span`
  font-size: ${font.size.xs};
  font-weight: 400;
  color: ${Black};
`;
